
































































import {Vue, Component, Prop, Ref} from 'vue-property-decorator'
import GenericTemplate from '@/pages/Pages/Templates/GenericTemplate.vue';
import {SmsTextInputWings} from '@/components/SMS';
import {MsgTransports} from '@/store/types';
import {SmsTemplateItemImpl} from '@/store/settings/templates/types';

Component.registerHooks([
  'beforeRouteLeave',
]);
@Component({
  components: {
    GenericTemplate,
    SmsTextInputWings
  }
})
export default class SmsTemplate extends Vue {
  @Prop() moderation!: boolean;
  @Ref('genericTemplate') genericTemplate: any;
  private transport: MsgTransports = MsgTransports.SMS;
  private templateObject: SmsTemplateItemImpl = new SmsTemplateItemImpl();

  beforeRouteLeave(to: any, from: any, next: any) {
    this.genericTemplate.beforeLeave(to, from, next)
  }

  onLoadTemplate(status: string) {
    if (this.moderation) {
      this.$emit('onLoadTemplate', status)
    }
  }
}
